import $ from 'jquery';
import gsap from 'gsap';
import TweenMax from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swal from 'sweetalert2';


gsap.registerPlugin(ScrollTrigger);

// Mobilde adres çubuğu gizlenip göründüğünde resize tetikleniyor ve ScrollTrigger
// scroll'un ortasında yeniden ölçüm yapıp pinleri sıçratıyor. Sadece yükseklik
// değişiyorsa bunu yok say.
ScrollTrigger.config({ ignoreMobileResize: true });

// Web font'lar yüklenince metin blokları yeniden akıyor ve bölümlerin konumu
// kayıyor; ScrollTrigger font yüklenmesini kendiliğinden beklemiyor.
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => ScrollTrigger.refresh());
}
import Scrollbar from 'smooth-scrollbar';
window.Scrollbar = Scrollbar;

require('owl.carousel');
require('jquery-validation');

var isTR = $('body').attr('data-content-language') === 'tr';

$(function () {
    const lockIntroScroll = () => {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        $('body')
            .addClass('intro-scroll-locked')
            .css('padding-right', scrollbarWidth > 0 ? `${scrollbarWidth}px` : '');
    };

    const unlockIntroScroll = () => {
        $('body')
            .removeClass('intro-scroll-locked')
            .css('padding-right', '');

        // Intro boyunca body overflow:hidden olduğu için ScrollTrigger hem ilk
        // kurulumda hem de window.load'da sayfayı scroll edilemez halde ölçüyor.
        // Kilit açıldıktan sonra yeniden ölçmezsek tüm pin başlangıçları bayat
        // kalıyor ve bölümler geç pinlenip geri sıçrıyor.
        ScrollTrigger.refresh();
    };

    $('body.basic-page .card-body.rich-text table').each(function () {
        const $table = $(this);

        if (!$table.parent().hasClass('table-scroll-wrapper')) {
            $table.wrap('<div class="table-scroll-wrapper"></div>');
        }
    });

    const floatingHeader = document.querySelector('.floating');
    const mobileBackToTop = document.querySelector('.mobile-back-to-top');
    const footer = document.querySelector('footer');
    const scrollThreshold = 100;
    function handleScroll() {
        const isPastHeader = window.scrollY > scrollThreshold;
        const footerTopOffset = footer.getBoundingClientRect().top + window.scrollY;
        const isBeforeFooter = window.scrollY + window.innerHeight < footerTopOffset;
        const isMobileViewport = window.innerWidth <= 1024;

        if (isPastHeader && isBeforeFooter) {
            floatingHeader.style.bottom = '15px';
            floatingHeader.style.opacity = '1';
        } else {
            floatingHeader.style.bottom = '-100px';
            floatingHeader.style.opacity = '0';
        }

        if (isMobileViewport && isPastHeader && isBeforeFooter) {
            mobileBackToTop.classList.add('is-visible');
        } else {
            mobileBackToTop.classList.remove('is-visible');
        }
    }

    window.addEventListener('scroll', handleScroll);

    // Intro (soldaki yil sayaci + sagdaki ucak) kullanici basina gunde bir kez oynar.
    // localStorage'da en son oynatildigi takvim gunu (YYYY-MM-DD) tutuluyor; <head>'deki
    // script de ayni anahtari okuyup sayfa boyanmadan once .intro-seen sinifini ekliyor
    // ki intro bir an gorunmesin.
    const INTRO_SEEN_KEY = 'hititIntroSeen';

    // Ziyaretcinin yerel takvim gunu. Saat dilimi kaymasi olmasin diye UTC/ISO degil,
    // cihazin kendi tarihinden uretiliyor. Esi: <head>'deki inline script.
    const introTodayStamp = () => {
        const now = new Date();
        const pad = (n) => (n < 10 ? '0' + n : '' + n);
        return now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    };

    const hasSeenIntro = () => {
        try {
            return window.localStorage && localStorage.getItem(INTRO_SEEN_KEY) === introTodayStamp();
        } catch (e) {
            return false; // Depolama okunamiyorsa intro oynasin.
        }
    };

    const markIntroSeen = () => {
        try {
            localStorage.setItem(INTRO_SEEN_KEY, introTodayStamp());
        } catch (e) {
            // Yazamiyorsak intro her ziyarette oynar; islevsel bir sorun degil.
        }
    };

    // Daha once izlenmisse intro'yu hic kurma: DOM'dan cikar, icerigi gorunur birak.
    // Scroll hic kilitlenmedigi icin unlockIntroScroll'a da gerek yok.
    if ($('.intro').length > 0 && hasSeenIntro()) {
        document.documentElement.classList.add('intro-seen');
        $('.intro').remove();
        $('.wrapper').css('opacity', 1);
    }

    if ($('.intro').length > 0) {
        // Basladigi anda isaretliyoruz: intro sirasinda yenilenirse tekrar oynamasin.
        markIntroSeen();
        lockIntroScroll();

        var isTR = $('body').attr('data-content-language') === 'tr';
        var h1ExtraDelay = isTR ? 3000 : 1500;

        var target1 = $('.intro .left-column em:first-child');
        var target2 = $('.intro .left-column em:nth-child(2)');
        var isMobile = window.innerWidth <= 1024;
        var targetBottom = isMobile ? '45%' : '32%';
        var animDuration1 = isMobile ? 1500 : 2000;
        var animDuration2 = isMobile ? 2000 : 3000;

        target2.css('opacity', .5);
        target2.delay(250).animate({
            bottom: targetBottom, opacity: 0
        }, {
            duration: animDuration2,
        });

        target1.css('opacity', 1);
        target1.delay(250).animate({
            bottom: targetBottom
        }, {
            duration: animDuration1,
        });

        var i = 1991;
        var timer = setInterval(function () {
            if (i < 2026) {
                target1.text(i + 1);
                target2.text(i);
                i++;
            } else {
                clearInterval(timer);
                $('.intro .right-column h1').animate({
                    opacity: 1
                }, {
                    duration: 1000,
                    complete: function () {
                        // TR: 1100ms, diğer diller: 100ms ekranda kalır
                        setTimeout(function () {
                            $('.intro .left-column em').animate({
                                opacity: 0,
                            }, {
                                duration: 500,
                            });
                            $('.intro .right-column h1').animate({
                                opacity: 0,
                            }, {
                                duration: 500,
                            });
                        }, 100 + h1ExtraDelay);
                    }
                });
            }
        }, 50);

        var plane = $('.intro .plane-wrapper .plane');
        plane.animate({
            bottom: '250%'
        }, {
            duration: 6000 + h1ExtraDelay,
            complete: function () {
                $('.intro').fadeOut(500, function () {
                    $(this).remove();
                    unlockIntroScroll();
                    $('.wrapper').animate({
                        opacity: 1
                    }, {
                        duration: 500,
                    });
                });
            }
        });

        var logo = $('.intro .logo-wrapper');
        logo.delay(4000 + h1ExtraDelay).animate({
            bottom: '50%',
            opacity: 1,
            'transform': 'translate(-50%, 50%) scale(1.2)'
        }, {
            duration: 1000,
        });

    }

});

$(window).on('load', function () {

    function normalizeInitialHashScroll() {
        var hash = window.location.hash;    
        if (!hash) {
            return;
        }

        var target = document.querySelector(hash);

        if (!target) {
            return;
        }

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        setTimeout(function () {           
            var top = target.getBoundingClientRect().top + window.pageYOffset;           
            window.scrollTo({ top: top, behavior: 'smooth' });
        }, 50);
    }

    function getResponsivePx(baseSize) {
        let currentWidth = window.innerWidth;
        if (currentWidth <= 768) {
            return (baseSize * 0.5) + 'px'; // Mobil cihazlar için
        }
        else
            //if (currentWidth <= 1024) {
            //     return (baseSize * 0.6) + 'px'; // Tabletler için
            // } else 
            if (currentWidth <= 1440) {
                return (baseSize * 0.8) + 'px';
            } else {
                return baseSize + 'px';
            }
    }

    const mobileNavBreakpoint = window.matchMedia('(max-width: 1024px)');
    const $headerMenuItems = $('header:not(.floating) .menu > ul > li.menu-item-has-children');

    function isMobileNavViewport() {
        return mobileNavBreakpoint.matches;
    }

    function closeDesktopMenus() {
        $headerMenuItems.removeClass('active');
        $('body').removeClass('menu-open');
    }

    // Hamburger menu logic start
    const $hamburger = $('header:not(.floating) .nav__hamburger');
    const $navPanel = $('header:not(.floating) .header-nav-panel');

    function openMobileNav() {
        $navPanel.addClass('is-open');
        $hamburger.attr('aria-expanded', 'true');
        $('body').addClass('mobile-nav-open');
    }

    function closeMobileNav() {
        $navPanel.removeClass('is-open');
        $hamburger.attr('aria-expanded', 'false');
        $('body').removeClass('mobile-nav-open');
        $headerMenuItems.removeClass('active');
    }

    $hamburger.on('click', function () {
        closeDesktopMenus();

        if ($navPanel.hasClass('is-open')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });

    $(document).on('click', '.nav__close', function () {
        closeMobileNav();
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $navPanel.hasClass('is-open')) {
            closeMobileNav();
            return;
        }

        if (e.key === 'Escape') {
            closeDesktopMenus();
        }
    });
    // Hamburger menu logic end

    $('header:not(.floating) .menu-item-has-children > a').on('click', function (e) {
        const $parent = $(this).parent();
        const isActive = $parent.hasClass('active');

        if (isMobileNavViewport() && $parent.hasClass('mobile-direct-link')) {
            closeMobileNav();
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        $headerMenuItems.not($parent).removeClass('active');

        if (isMobileNavViewport()) {
            $parent.toggleClass('active', !isActive);
            return;
        }

        if (isActive) {
            closeDesktopMenus();
        } else {
            $parent.addClass('active');
            $('body').addClass('menu-open');
        }
    });

    $('header:not(.floating) .dropdown-menu').on('click', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', function (e) {
        if ($('body').hasClass('mobile-nav-open')) {
            return;
        }

        if (!$(e.target).closest('header:not(.floating) .menu-item-has-children').length) {
            closeDesktopMenus();
        }
    });

    $('.menu-overlay').on('click', function () {
        closeDesktopMenus();
        closeMobileNav();
    });

    $(window).on('resize', function () {
        if (!isMobileNavViewport()) {
            closeMobileNav();
            closeDesktopMenus();
        }
    });

    $('header:not(.floating) .dropdown-menu a, header:not(.floating) .nav__mobile-footer a, header:not(.floating) .mobile-direct-link > a').on('click', function () {
        closeDesktopMenus();

        if (isMobileNavViewport()) {
            closeMobileNav();
        }
    });

    function initYearFilterQueryParam() {
        var yearFilterSelects = document.querySelectorAll('select[name="list-filter"]');

        if (!yearFilterSelects.length) {
            return;
        }

        var currentUrl = new URL(window.location.href);
        var selectedYearFromQuery = currentUrl.searchParams.get('year');

        Array.prototype.forEach.call(yearFilterSelects, function (selectElement) {
            var matchingOption = selectElement.querySelector('option[value="' + selectedYearFromQuery + '"]');

            if (selectedYearFromQuery && matchingOption) {
                selectElement.value = selectedYearFromQuery;
            }

            selectElement.addEventListener('change', function () {
                var nextUrl = new URL(window.location.href);
                var nextValue = selectElement.value;

                if (!nextValue || nextValue === 'all') {
                    nextUrl.searchParams.delete('year');
                } else {
                    nextUrl.searchParams.set('year', nextValue);
                }

                window.location.href = nextUrl.toString();
            });
        });
    }

    initYearFilterQueryParam();

    if ($('.home-page').length > 0) {
        const homeAboutMM = gsap.matchMedia();

        // --- Masaüstü animasyonu ---
        homeAboutMM.add("(min-width: 801px)", () => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.home-about",
                    start: "top top",
                    end: "+=600",
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true
                }
            });

            tl.to("section.home-about .image-wrapper", {
                width: '50%',
                duration: 1
            }, 0);

            tl.to("section.home-about", {
                backgroundColor: "#FFFFFF",
                duration: 1
            }, 1);

            tl.to("section.home-about .content-wrapper", {
                width: '50%',
                display: 'block',
                duration: 1
            }, 0);

            tl.to("section.home-about .content-wrapper .content-inner-wrapper", {
                opacity: 1,
                display: 'block',
                duration: 1,
                ease: "power2.out"
            }, 1);
        });

        // --- Mobil animasyonu (≤800px) ---
        homeAboutMM.add("(max-width: 800px)", () => {
            // Masaüstü inline stillerini sıfırla
            gsap.set("section.home-about", { backgroundColor: "" });
            gsap.set("section.home-about .image-wrapper", { width: "", marginTop: "-20px" });
            gsap.set("section.home-about .content-wrapper", {
                width: "100%",
                display: "block",
                y: "15%",
            });
            gsap.set("section.home-about .content-wrapper .content-inner-wrapper", {
                display: "block",
                opacity: 1,
            });

            const tlMobile = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.home-about",
                    start: "top bottom",
                    // "bottom bottom": parallax tam da bölümün alt kenarı ekranın altına
                    // geldiği anda biter. Böylece alttaki negatif margin'in çakışma yarattığı
                    // düşük progress anları hep ekran dışında kalıyor.
                    end: "bottom bottom",
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            });

            // DİKKAT: Burada marginTop animate EDİLMEZ. Layout özelliği olduğu için
            // bölümün yüksekliği scroll'la değişiyor, altındaki pinli our-solutions'ın
            // başlangıç noktası kayıyor ve pin geç tetiklenip geri sekiyordu.
            // Aynı hareketi transform ile yapıyoruz; transform layout'u etkilemez.
            // Kutunun dibinde kalan boşluk CSS'teki -120px margin-bottom ile telafi ediliyor.

            // image-wrapper: 100px yukarı (eski -20px → -120px marginTop karşılığı)
            tlMobile.to("section.home-about .image-wrapper", {
                y: -100,
                ease: "none",
            }, 0);

            // content-wrapper: görselin 100px'i + 15px yakınlaşma payı = 115px yukarı.
            // İki ayar birbirine bağlı, değiştirirken ikisini birlikte düşün:
            //   * bu değer - 100  =  başlık ile görsel arasındaki yakınlaşma (şu an 15px)
            //   * bu değer - CSS'teki margin-bottom  =  kutunun dibinde kalan boşluk
            //     (115 - 95 = 20px)
            tlMobile.to("section.home-about .content-wrapper", {
                y: -115,
                ease: "none",
            }, 0);
        });

        const transationMM = gsap.matchMedia();

        // --- Masaüstü: pin + yükseklik küçülmesi ---
        transationMM.add("(min-width: 801px)", () => {
            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.transation-section",
                    start: "top top",
                    end: "+=500",
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                    invalidateOnRefresh: true
                }
            });

            tl2.fromTo("section.transation-section .image-wrapper", {
                height: window.innerHeight + 'px'
            }, {
                height: '50vh',
                duration: 1
            }, 0);

            gsap.to("section.transation-section .content-wrapper", {
                opacity: 1,
                y: 0,
                duration: .9,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: "section.transation-section .content-wrapper",
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        });

        // --- Mobil: pin yok, genişlik 80% → 100% parallax ---
        transationMM.add("(max-width: 800px)", () => {
            // width yerine scale: width animasyonu height:auto ile birleşince görselin
            // yüksekliği de büyüyor ve altındaki pinli our-solutions'ın konumu kayıyor.
            // scale aynı büyümeyi layout'u hiç değiştirmeden veriyor.
            gsap.set("section.transation-section .image-wrapper", {
                height: "auto",
                width: "100%",
                transformOrigin: "center top",
            });

            gsap.fromTo("section.transation-section .image-wrapper", {
                scale: 0.8,
            }, {
                scale: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: "section.transation-section",
                    start: "top bottom",
                    end: "center center",
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            });

            gsap.to("section.transation-section .content-wrapper", {
                opacity: 1,
                y: 0,
                duration: .9,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: "section.transation-section .content-wrapper",
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            });
        });
    

        const setActiveTab = (index) => {
            $("section.our-solutions .tabs-wrapper .tab").removeClass('active');
            $("section.our-solutions .tabs-wrapper .tab:nth-child(" + index + ")").addClass('active');
        };

        const solutionsTimeMM = gsap.matchMedia();

        solutionsTimeMM.add("(max-width: 800px)", () => {
            const solutionsSection = document.querySelector('section.our-solutions');
            const solutionsInner = solutionsSection && solutionsSection.querySelector('.our-solutions-inner-wrapper');
            const solutionsWrapper = solutionsSection && solutionsSection.querySelector('.solutions-wrapper');
            const solutionCards = gsap.utils.toArray('section.our-solutions .solutions-wrapper .solution');

            if (!solutionsSection || !solutionsInner || !solutionsWrapper || !solutionCards.length) return;

            gsap.set(solutionCards, { opacity: 1 });

            const headingEl = solutionsSection.querySelector('.heading-wrapper .heading-inner-wrapper h2');

            // GSAP animasyon sırasında inline font-size yazıyor; CSS'teki asıl boyutu
            // okumak için inline değeri geçici olarak temizliyoruz.
            const getHeadingBaseSize = () => {
                if (!headingEl) return 0;
                const inlineSize = headingEl.style.fontSize;
                headingEl.style.fontSize = '';
                const base = parseFloat(window.getComputedStyle(headingEl).fontSize) || 0;
                headingEl.style.fontSize = inlineSize;
                return base;
            };

            // Mobilde başlık çok küçülünce satır sayısı değişiyor ve altındaki her şey
            // tek karede yukarı sıçrıyor. Bu yüzden sadece hafif bir küçülme: 32px → 28px.
            const getHeadingTargetSize = () => {
                const base = getHeadingBaseSize();
                return base ? Math.round(base * 0.875) + 'px' : '';
            };

            // Başlık küçülünce .solutions-wrapper yukarı kayıyor; park halindeki kartlar
            // da onunla yukarı çıkıp ekranın altından görünüyor. Kalan küçülme payını
            // hedef font'u bir an uygulayıp birebir ölçüyoruz.
            const getHeadingShrink = () => {
                if (!headingEl) return 0;
                const before = headingEl.offsetHeight;
                const inlineSize = headingEl.style.fontSize;
                headingEl.style.fontSize = getHeadingTargetSize();
                const after = headingEl.offsetHeight;
                headingEl.style.fontSize = inlineSize;
                return Math.max(0, before - after);
            };

            // Kartların park pozisyonu: bölümün alt kenarının hemen altı.
            // 900px taban, ölçüm herhangi bir sebeple şaşarsa bile kart ekranın
            // altından görünmesin diye. power1.out ease'i ekran dışı kalan kısmı hızlı geçiyor.
            const getCardStartY = () => {
                const distance = solutionsInner.offsetHeight - solutionsWrapper.offsetTop
                    + getHeadingShrink() + 24;
                return Math.max(distance, 900);
            };

            // Kart yüksekliğini ölç, peek miktarını dinamik hesapla
            const getCardPeek = (index) => {
                const peek = solutionCards[0].offsetHeight * 0.075;
                return 'translateX(-50%) translateY(' + (index * peek) + 'px)';
            };

            const getCardOffscreen = () => 'translateX(-50%) translateY(' + getCardStartY() + 'px)';

            // Giriş: bölüm ekrana girerken başlık küçülür, sekmeler belirir ve 1. kart gelir.
            // Hepsi pin başlamadan biter; böylece pin anında layout değişmez, zıplama olmaz.
            const solutionsIntro = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.our-solutions",
                    start: "top 60%",
                    end: "top top",
                    // Yumuşatmalı scrub pin sınırında gecikme yaratıp zıplamaya sebep oluyor
                    scrub: true,
                    invalidateOnRefresh: true,
                    onEnter: () => setActiveTab(1),
                    onEnterBack: () => setActiveTab(1),
                },
            });

            solutionsIntro.to("section.our-solutions .heading-wrapper .heading-inner-wrapper", {
                paddingTop: '0',
                duration: 0.3,
                ease: "none",
            }, 0);

            solutionsIntro.to("section.our-solutions .heading-wrapper .heading-inner-wrapper h2", {
                fontSize: () => getHeadingTargetSize(),
                duration: 0.3,
                ease: "none",
            }, 0);

            // Sekmeler kart gelmeden önce yerini alsın
            solutionsIntro.to("section.our-solutions .tabs-wrapper", {
                opacity: 1,
                duration: 0.25,
                ease: "none",
            }, 0.2);

            solutionsIntro.fromTo("section.our-solutions .solutions-wrapper .solution:first-child",
                { transform: getCardOffscreen },
                {
                    transform: () => getCardPeek(1),
                    duration: 0.65,
                    ease: "power1.out",
                }, 0.35);

            // İlk kart pin'den önce geldiği için pinli alanda sadece 3 kart kalıyor
            const cardCount = solutionCards.length - 1;
            const scrollPerCard = window.innerHeight * 0.55;
            const totalScroll = Math.round(cardCount * scrollPerCard);
            const solutionsTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.our-solutions",
                    start: "top top",
                    end: "+=" + totalScroll,
                    // Pin bırakılırken kartların savrulmaması için gecikmesiz scrub
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true,
                },
            });

            solutionsTimeline.fromTo("section.our-solutions .solutions-wrapper .solution:nth-child(2)",
                { transform: getCardOffscreen },
                {
                    transform: () => getCardPeek(2),
                    opacity: 1,
                    duration: 0.5,
                    ease: "power1.out",
                    onComplete: () => setActiveTab(2),
                    onReverseComplete: () => setActiveTab(1),
                }, 0);

            solutionsTimeline.fromTo("section.our-solutions .solutions-wrapper .solution:nth-child(3)",
                { transform: getCardOffscreen },
                {
                    transform: () => getCardPeek(3),
                    opacity: 1,
                    duration: 0.5,
                    ease: "power1.out",
                    onComplete: () => setActiveTab(3),
                    onReverseComplete: () => setActiveTab(2),
                }, 0.45);

            solutionsTimeline.fromTo("section.our-solutions .solutions-wrapper .solution:nth-child(4)",
                { transform: getCardOffscreen },
                {
                    transform: () => getCardPeek(4),
                    opacity: 1,
                    duration: 0.5,
                    ease: "power1.out",
                    onComplete: () => setActiveTab(4),
                    onReverseComplete: () => setActiveTab(3),
                }, 0.9);

            // Son kart yerine oturduktan sonra kısa bir nefes payı
            solutionsTimeline.to({}, { duration: 0.15 }, 1.4);
        })

        solutionsTimeMM.add("(min-width: 801px)", () => {

            const solutionsTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.our-solutions",
                    start: "top top",
                    end: "+=3000",
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true, // Ekran küçüldüğünde hesaplanması için gerekli
                },
            });

            solutionsTimeline.to("section.our-solutions .heading-wrapper .heading-inner-wrapper", {
                "paddingTop": '0',
                duration: 0.2,
                complete: function () {
                }
            }, 0);

            solutionsTimeline.to("section.our-solutions .heading-wrapper .heading-inner-wrapper h2", {
                fontSize: () => getResponsivePx(44), // Çarpanlı metodu çağırıyoruz
                duration: 0.2,   // %20'de tamamla
            }, 0); // Padding animasyonuyla aynı anda başla


            solutionsTimeline.to("section.our-solutions .tabs-wrapper", {
                opacity: 1,
                duration: 0.5,
            }, 0);

            solutionsTimeline.to("section.our-solutions .solutions-wrapper .solution:first-child", {
                transform: () => 'translateX(-50%) translateY(' + getResponsivePx(30) + ')',
                opacity: 1,
                duration: 0.5,
                onStart: () => setActiveTab(1),
                onReverseComplete: () => setActiveTab(1)
            }, .2);

            solutionsTimeline.to("section.our-solutions .solutions-wrapper .solution:nth-child(2)", {
                transform: () => 'translateX(-50%) translateY(' + getResponsivePx(45) + ')',
                opacity: 1,
                duration: 0.5,
                onComplete: () => setActiveTab(2),
                onReverseComplete: () => setActiveTab(1)
            }, .7);

            solutionsTimeline.to("section.our-solutions .solutions-wrapper .solution:nth-child(3)", {
                transform: () => 'translateX(-50%) translateY(' + getResponsivePx(60) + ')',
                opacity: 1,
                duration: 0.5,
                onComplete: () => setActiveTab(3),
                onReverseComplete: () => setActiveTab(2)
            }, 1.2);

            solutionsTimeline.to("section.our-solutions .solutions-wrapper .solution:nth-child(4)", {
                transform: () => 'translateX(-50%) translateY(' + getResponsivePx(75) + ')',
                opacity: 1,
                duration: 0.5,
                onComplete: () => setActiveTab(4),
                onReverseComplete: () => setActiveTab(3)
            }, 1.7);


        });

        const communityMM = gsap.matchMedia();

        // grid-wrapper başlangıçta fixed ile viewport dışında bekler
        gsap.set(".home-page .grid-wrapper", {
            position: 'fixed',
            top: '100vh',
            left: 0,
            right: 0,
            zIndex: 12
        });

        const buildCommunityTimeline = (isMobile) => {
            const minScroll = isMobile ? 4000 : 4500;

            const ct = gsap.timeline({
                scrollTrigger: {
                    trigger: "section.community",
                    start: "top top",
                    // Animasyon süresi + grid-wrapper'ın tam ekrana girmesi için 1 viewport ekle
                    end: "+=" + (minScroll + window.innerHeight),
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true,
                    onLeave: () => {
                        gsap.set(".home-page .grid-wrapper", {
                            clearProps: 'position,top,left,right',
                            marginTop: -window.innerHeight + 'px'
                        });
                        // Layout değişti, tüm ScrollTrigger pozisyonlarını yeniden hesapla
                        ScrollTrigger.refresh();
                    },
                    onEnterBack: () => {
                        gsap.set(".home-page .grid-wrapper", {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 12,
                            clearProps: 'marginTop'
                        });
                    },
                    onLeaveBack: () => {
                        gsap.set(".home-page .grid-wrapper", {
                            position: 'fixed',
                            top: '100vh',
                            left: 0,
                            right: 0,
                            zIndex: 12,
                            clearProps: 'marginTop'
                        });
                    }
                },
            });

            // Kartlar sola kayar (0→2)
            ct.fromTo("section.community .community-inner-wrapper .cards-wrapper", {
                x: () => {
                    const wrapper = document.querySelector('section.community .community-inner-wrapper .cards-wrapper');
                    const firstCard = wrapper?.querySelector('.card');
                    if (wrapper && firstCard) {
                        return -(firstCard.offsetWidth + (isMobile ? 30 : 60)) + 'px';
                    }
                    return '-100vw';
                }
            }, {
                x: () => {
                    const wrapper = document.querySelector('section.community .community-inner-wrapper .cards-wrapper');
                    return wrapper ? -(wrapper.scrollWidth) + 'px' : (isMobile ? '-300vw' : '-220vw');
                },
                duration: 2,
                ease: 'linear'
            }, 0);

            // Wrapper sola çekilir + köşe radius (2→3)
            ct.to("section.community .community-inner-wrapper", {
                x: '-100vw',
                duration: 1,
                ease: 'linear'
            }, 2);

            ct.to("section.community .community-inner-wrapper", {
                borderTopRightRadius: '32px',
                borderBottomRightRadius: '32px',
                duration: 0,
            }, 2);

            const planeDuration = isMobile ? 2.5 : 2;
            const planeStart    = 3;
            const headingStart  = 3;
            const h2Start       = isMobile ? 4 : 4;

            // Uçak, heading, h2 (3→5)
            ct.to("section.community .impact-wrapper .plane-wrapper", {
                right: '100%',
                duration: planeDuration,
                ease: 'linear'
            }, planeStart);

            ct.to("section.community .impact-wrapper .impact-heading-wrapper .impact-heading-inner-wrapper", {
                paddingTop: '0',
                duration: 1,
                ease: 'linear'
            }, headingStart);

            ct.to("section.community .impact-wrapper .impact-heading-wrapper .impact-heading-inner-wrapper h2", {
                fontSize: () => getResponsivePx(isMobile ? 32 : 44),
                duration: 1,
            }, h2Start);

            // grid-wrapper aşağıdan yukarı kayar — fixed olduğu için layout bozulmaz (5→7)
            ct.to(".home-page .grid-wrapper", {
                top: 0,
                duration: 2,
                ease: 'none'
            }, 5);

            return ct;
        };

        communityMM.add("(min-width: 801px)", () => {
            buildCommunityTimeline(false);

            gsap.to(".home-page .sustainability-wrapper .content-wrapper", {
                y: '-50%',
                scrollTrigger: {
                    trigger: ".home-page .sustainability-wrapper",
                    start: "top 100%",
                    end: "bottom 100%",
                    scrub: true,
                }
            });
        });

        communityMM.add("(max-width: 800px)", () => {
            buildCommunityTimeline(true);

            gsap.to(".home-page .sustainability-wrapper .content-wrapper", {
                y: '-50%',
                scrollTrigger: {
                    trigger: ".home-page .sustainability-wrapper",
                    start: "top 100%",
                    end: "bottom 100%",
                    scrub: true
                }
            });
        });        

        

        // Mobilde solution kartlarını en yüksek kart kadar eşitle
        if (window.innerWidth <= 800) {
            var $solutions = $('section.our-solutions .solutions-wrapper .solution');
            if ($solutions.length > 0) {
                $solutions.css('height', '');
                var maxH = 0;
                $solutions.each(function () {
                    maxH = Math.max(maxH, $(this).outerHeight());
                });
                $solutions.css('height', maxH + 'px');

                // Kart yükseklikleri değiştiği için scroll hesaplarını tazele
                ScrollTrigger.refresh();
            }
        }

    }

    //about page
    if ($('.about-page').length > 0) {
        const heroImageMM = gsap.matchMedia();

        heroImageMM.add("(min-width: 801px)", function () {
            gsap.to(".about-page .hero .team-item-image", {
                scale: 1,
                transformOrigin: "center center",
                scrollTrigger: {
                    trigger: ".about-page .hero",
                    start: "top 75%",
                    end: "bottom 30%",
                    scrub: true,
                }
            });
        });

        heroImageMM.add("(max-width: 800px)", function () {
            gsap.to(".about-page .hero .team-item-image", {
                scale: 1,
                transformOrigin: "center center",
                scrollTrigger: {
                    trigger: ".about-page .hero",
                    start: "top 95%",   // çok daha erken başla
                    end: "center 20%",  // daha geç bitir → uzun scroll aralığı
                    scrub: 1.5,         // biraz yumuşak
                }
            });
        });

        var aboutSustainabilityMedia = gsap.matchMedia();
        var aboutSustainabilityCard = ".about-page .sustainability-wrapper .content-wrapper";

        aboutSustainabilityMedia.add("(min-width: 577px)", function () {
            gsap.to(aboutSustainabilityCard, {
                y: '-50%',
                scrollTrigger: {
                    trigger: ".about-page .sustainability-wrapper",
                    start: "top top",
                    end: "bottom top",
                    scrub: true,
                }
            });
        });

        aboutSustainabilityMedia.add("(max-width: 576px)", function () {
            gsap.to(aboutSustainabilityCard, {
                y: '-50%',
                scrollTrigger: {
                    trigger: ".about-page .sustainability-wrapper",
                    start: "top 75%",
                    end: "bottom -20%",
                    scrub: true,
                }
            });
        });

        // Owl instance'ını oluşturuyoruz.
        // Şimdilik mevcut config'i bozmuyoruz, sadece event mantığını iyileştireceğiz.
        var owlMilestones = $('.our-history .milestones').owlCarousel({
            margin: 10,
            loop: false,
            rewind: false,
            nav: false,
            items: 1,
            stagePadding: 300,
            responsive: {
                0: {
                    // Mobilde içerik çok sıkışmasın ama preview de tamamen kaybolmasın
                    stagePadding: 40
                },
                481: {
                    // Tablet civarında biraz preview bırakıyoruz
                    stagePadding: 80
                },
                1201: {
                    // Desktop'ta aktif item'ı fazla ortaya itmemen için daha kontrollü padding
                    stagePadding: 160
                },
                1440: {
                    // Büyük ekranlarda da 240 yerine daha ölçülü bir değer deniyoruz
                    stagePadding: 160
                }
            },

            onInitialized: function (e) {
                updateProgressBar(e);
                syncPrimaryFocus(e);
            },

            // Hareket başlarken aktif class'ı erkenden güncelliyoruz.
            // Böylece yeni slide ekrana gelirken "önce küçük sonra büyük" hissi azalır.
            onTranslate: function (e) {
                syncPrimaryFocus(e);
            },

            // Hareket bitince hem progress'i hem de aktif durumu tekrar garantiye alıyoruz.
            onTranslated: function (e) {
                updateProgressBar(e);
                syncPrimaryFocus(e);
            },

            onRefreshed: function (e) {
                syncPrimaryFocus(e);
            }
        });


        // Bu fonksiyonun görevi:
        // Owl'ın o an aktif kabul ettiği item'ı bulup
        // sadece ona "primary-focus" class'ı vermek.
        function syncPrimaryFocus(e) {
            // Event içinden Owl instance'ına erişiyoruz.
            // Böylece dışarıdan tekrar tekrar DOM okumamıza gerek kalmıyor.
            var owl = e.relatedTarget;

            // Güvenlik kontrolü:
            // Herhangi bir sebeple owl yoksa fonksiyondan çık.
            if (!owl) return;

            // Owl current() ile mevcut internal index'i verir.
            // relative() ile clone/offset gibi durumları normalize edip
            // bizim gerçek item index'imizi alıyoruz.
            var currentIndex = owl.relative(owl.current());

            // Sadece bu section içindeki milestones carousel'ini hedefliyoruz.
            var $carousel = $('.our-history .milestones');

            // Önce tüm owl-item'lardan aktif class'ı kaldırıyoruz.
            $carousel.find('.owl-item').removeClass('primary-focus');

            // Sonra gerçek index'e karşılık gelen owl-item'ı bulup
            // sadece ona aktif class veriyoruz.
            $carousel.find('.owl-item').eq(currentIndex).addClass('primary-focus');
        }


        // Progress bar fonksiyonu şimdilik korunuyor.
        // Bu stepte ana hedef active state yönetimini düzeltmek.
        function updateProgressBar(e) {
            var index = e.item.index;
            var count = e.item.count;
            var size = e.page.size;

            var maxIndex = count - size;
            var totalSteps = Math.ceil(maxIndex) + 1;
            var currentStep = index + 1;

            var percentage = Math.round((currentStep / totalSteps) * 100);

            if (index >= maxIndex) {
                percentage = 100;
            }

            if (percentage < 0) percentage = 0;

            $('.progress-active').css('width', percentage + '%');

            var $prevBtn = $('.prev-btn');
            var $nextBtn = $('.next-btn');

            if (index <= 0) {
                $prevBtn.addClass('disabled');
            } else {
                $prevBtn.removeClass('disabled');
            }

            if (index >= maxIndex) {
                $nextBtn.addClass('disabled');
            } else {
                $nextBtn.removeClass('disabled');
            }
        }

        // Custom next button
        $('.milestones-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();

            if (!$(this).hasClass('disabled')) {
                owlMilestones.trigger('next.owl.carousel');
            }
        });

        // Custom prev button
        $('.milestones-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();

            if (!$(this).hasClass('disabled')) {
                owlMilestones.trigger('prev.owl.carousel');
            }
        });

        var teamsOwl = $('.about-page .leadership .team-wrapper .people').owlCarousel({
            margin: 30,
            loop: false,
            rewind: false,
            nav: false,
            dots : false,
            items: 2,
            //stagePadding: 300,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 0,
                },
                576: {
                    items: 2,
                    stagePadding: 0,
                },
                801: {
                    items: 3,
                    stagePadding: 0,
                },
                1024: {
                    items: 3,
                    stagePadding: 0,
                },
                1440: {
                    items: 4,
                    stagePadding: 0,
                },
            },
        });

        $('.about-page .leadership .team-wrapper .slider-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();
            teamsOwl.trigger('next.owl.carousel');
        });

        $('.about-page .leadership .team-wrapper .slider-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();
            teamsOwl.trigger('prev.owl.carousel');
        });

        $('.about-page .leadership .team-wrapper .person-details-closer').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $detailElement = $(this).closest('.person-details-wrapper');
            var $originalParent = $('.about-page .leadership .team-wrapper .person.active-person');
            $detailElement.removeClass('active');
            $('body').removeClass('modal-open');

            setTimeout(function () {
                $detailElement.appendTo($originalParent);
                $originalParent.removeClass('active-origin');
                $originalParent.removeClass('active-person');
            }, 300);

        });

        $('.about-page .leadership .team-wrapper .person').on('click', function (e) {
            e.preventDefault();
            var $personElement = $(this).addClass('active-person');
            var $detailElement = $personElement.find('.person-details-wrapper');
            $detailElement.appendTo('main');
            setTimeout(function () {
                $detailElement.addClass('active');
                $('body').addClass('modal-open'); // Scroll'u kilitlemek için
            }, 10);
        });

        var innovationStrengthOwl = $('.about-page .innovation-strength .innovation-cards').owlCarousel({
            margin: 34,
            loop: false,
            rewind: false,
            nav: false,
            dots: false,
            items: 3,
            stagePadding: 0,
            responsive: {
                0: {
                    items: 1,
                    margin: 20,
                },
                576: {
                    items: 2,
                    margin: 24,
                },
                1024: {
                    items: 3,
                    margin: 34,
                },
            },
        });

        $('.about-page .innovation-strength .slider-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();
            innovationStrengthOwl.trigger('next.owl.carousel');
        });

        $('.about-page .innovation-strength .slider-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();
            innovationStrengthOwl.trigger('prev.owl.carousel');
        });

        var associationsOwl = $('.about-page .associations .associations-wrapper .items').owlCarousel({
            margin: 30,
            loop: false,
            rewind: false,
            nav: false,
            items: 4,
            stagePadding: 0,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 0,
                },
                576: {
                    items: 2,
                    stagePadding: 0,
                },
                801: {
                    items: 3,
                    stagePadding: 0,
                },
                1024: {
                    items: 3,
                    stagePadding: 0,
                },
                1440: {
                    items: 4,
                    stagePadding: 0,
                },
            },
        });

        $('.about-page .associations .associations-wrapper .slider-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();
            associationsOwl.trigger('next.owl.carousel');
        });

        $('.about-page .associations .associations-wrapper .slider-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();
            associationsOwl.trigger('prev.owl.carousel');
        });
    }

    if ($('.hitit-talks-page').length > 0) {
        Array.prototype.forEach.call(
            document.querySelectorAll('.hitit-talks-page .list-section .list-wrapper .issue-item .right-column .column-content'),
            function (el) {
                var scroller = new Scrollbar(el, {
                    alwaysShowTracks: true,
                    continuousScrolling: false,
                    overscrollEffect: true,
                    height: 300,
                    width: 'auto',
                })
            });

        setInterval(function () {
            $('.hitit-talks-page .list-section .list-wrapper .issue-item .left-column .list-item').each(function (index, element) {
                var h = $(element).outerHeight();
                $(element).parents('.issue-item').find('.right-column .column-content').css('height', h + 'px');
            });
        }, 100);
    }

    if ($('.contact-page').length > 0) {
        if (new URLSearchParams(window.location.search).get('subject') === 'demo-request') {
            $('.contact-page .contact-us select').each(function () {
                this.value = 'Inquiry / Demo Request Regarding a Solution';
                this.dispatchEvent(new Event('change', { bubbles: true }));
            });
        }

        var promotedImage = ".contact-page .promoted-image .promoted-image-content";
        var promotedImageTrigger = ".contact-page .promoted-image";
        var promotedImageMedia = gsap.matchMedia();
        var createPromotedImageAnimation = function (targetMaxWidth, start, end) {
            gsap.fromTo(promotedImage, {
                maxWidth: '100%',
            }, {
                maxWidth: targetMaxWidth,
                scrollTrigger: {
                    trigger: promotedImageTrigger,
                    start: start,
                    end: end,
                    scrub: true,
                    invalidateOnRefresh: true,
                }
            });
        };

        promotedImageMedia.add("(min-width: 1201px)", function () {
            createPromotedImageAnimation('980px', "top 75%", "bottom 20%");
        });

        promotedImageMedia.add("(min-width: 801px) and (max-width: 1200px)", function () {
            createPromotedImageAnimation('calc(100% - 80px)', "top 75%", "bottom 20%");
        });

        promotedImageMedia.add("(max-width: 800px)", function () {
            createPromotedImageAnimation('calc(50%)', "top 50%", "bottom top");
        });
    }

    if ($('body').is('.solutions-hitit-ads-page, .solutions-hitit-elektrum-page, .solutions-hitit-oxygen-page, .solutions-page-inner-page-crane, .ai-page')) {
        var adsImageRevealTargets = [
            '.content-section .card-image-wrapper'
        ];

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            gsap.set(adsImageRevealTargets.join(','), {
                opacity: 1,
                x: 0,
            });
        } else {
            var adsImageRevealMedia = gsap.matchMedia();

            var createAdsImageReveal = function (distance) {
                $(adsImageRevealTargets.join(',')).each(function () {
                    var $imageWrapper = $(this);
                    var direction = $imageWrapper.hasClass('align-right') || $imageWrapper.hasClass('image-column') ? 1 : -1;
                    var elementBounds = this.getBoundingClientRect();
                    var isVisibleOnLoad = elementBounds.top < window.innerHeight && elementBounds.bottom > 0;

                    if (isVisibleOnLoad) {
                        gsap.fromTo(this, {
                            opacity: 0,
                            x: distance * direction,
                        }, {
                            opacity: 1,
                            x: 0,
                            duration: 1.5,
                            ease: 'power3.out',
                        });
                    } else {
                        gsap.fromTo(this, {
                            opacity: 0,
                            x: distance * direction,
                        }, {
                            opacity: 1,
                            x: 0,
                            ease: 'none',
                            scrollTrigger: {
                                trigger: this,
                                start: 'top 92%',
                                end: 'top 62%',
                                scrub: 0.70,
                                invalidateOnRefresh: true,
                            }
                        });
                    }
                });
            };

            adsImageRevealMedia.add('(min-width: 801px)', function () {
                createAdsImageReveal(120);
            });

            adsImageRevealMedia.add('(max-width: 800px)', function () {
                createAdsImageReveal(60);
            });
        }
    }

    // Careers page
    if ($('.careers-page .file-upload-field').length > 0) {
        $('.careers-page .file-upload-field input[type="file"]').on('change', function () {
            var fileName = this.files && this.files.length > 0 ? this.files[0].name : 'No file chosen';
            $(this).siblings('.file-upload-name').text(fileName);
        });
    }

    // Job posting page
    if ($('.job-posting-page .file-upload-field').length > 0) {
        $('.job-posting-page .file-upload-field input[type="file"]').on('change', function () {
            var fileName = this.files && this.files.length > 0 ? this.files[0].name : 'No file chosen';
            $(this).siblings('.file-upload-name').text(fileName);
        });
    }

    // Akordiyon gövdesi display:none yerine height/padding ile sürülür ki açılış ve
    // kapanış yumuşak olsun. Ritim teragirisim.html ile aynı (400ms ease). Tüm
    // akordiyonlar aynı yapıda: .accordion-wrapper > .accordion-item >
    // .accordion-item-content (AI çözümleri, SSS, yönetim kurulu, finansal raporlar).
    // Kapalı durumun height:0 + padding:0 olması app.scss'te tanımlı.
    var ACCORDION_DURATION = 400;

    var readAccordionBounds = function (content) {
        var styles = window.getComputedStyle(content);

        return {
            height: styles.height,
            paddingTop: styles.paddingTop,
            paddingBottom: styles.paddingBottom,
        };
    };

    $(document).on('click', '.accordion-wrapper .accordion-item-header', function (e) {
        e.preventDefault();

        var item = this.parentNode;
        var content = item.querySelector('.accordion-item-content');
        var opening = !item.classList.contains('active');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // İçeriği olmayan akordiyon (ör. static-accordion) eskisi gibi sadece sınıf değiştirir.
        if (!content || reduceMotion || typeof content.animate !== 'function') {
            item.classList.toggle('active');
            return;
        }

        if (item.accordionAnimation) {
            item.accordionAnimation.cancel();
        }

        // Açılırken önce sınıfı ekleyip açık ölçüyü okuyoruz, kapanırken önce
        // ölçüp sonra sınıfı kaldırıyoruz; ikisinde de başlık/ikon anında dönüyor.
        var collapsed = { height: '0px', paddingTop: '0px', paddingBottom: '0px' };
        var expanded;

        if (opening) {
            item.classList.add('active');
            expanded = readAccordionBounds(content);
        } else {
            expanded = readAccordionBounds(content);
            item.classList.remove('active');
        }

        var from = opening ? collapsed : expanded;
        var to = opening ? expanded : collapsed;

        content.style.overflow = 'hidden';

        item.accordionAnimation = content.animate({
            height: [from.height, to.height],
            paddingTop: [from.paddingTop, to.paddingTop],
            paddingBottom: [from.paddingBottom, to.paddingBottom],
        }, { duration: ACCORDION_DURATION, easing: 'ease' });

        var cleanUp = function () {
            content.style.overflow = '';
            item.accordionAnimation = null;
            ScrollTrigger.refresh();
        };

        item.accordionAnimation.oncancel = cleanUp;
        item.accordionAnimation.onfinish = cleanUp;
    });
    

    // Solution page
    if ($('.solutions-page').length > 0) {
        var solutionsOwl = $('.solutions-page .solutions-section .solutions-wrapper').owlCarousel({
            margin: 30,
            stagePadding: 180,
            loop: false,
            rewind: false,
            nav: false,
            center: false,
            items: 1,
            responsive: {
                0: {
                    items: 1,
                    margin: 20,
                    stagePadding: 0,
                },
                576: {
                    items: 1,
                    margin: 20,
                    stagePadding: 20,
                },
                768: {
                    items: 1,
                    margin: 24,
                    stagePadding: 40,
                },
                1024: {
                    items: 1,
                    margin: 30,
                    stagePadding: 80,
                },
                1200: {
                    items: 1,
                    margin: 30,
                    stagePadding: 160,
                },
                1400: {
                    items: 1,
                    margin: 30,
                    stagePadding: 250,
                    center: true,
                },
                1680: {
                    items: 1,
                    margin: 30,
                    stagePadding: 400,
                    center: true,
                },
            },

        });

        $('.solutions-page .solutions-section .slider-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();
            solutionsOwl.trigger('next.owl.carousel');
        });

        $('.solutions-page .solutions-section .slider-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();
            solutionsOwl.trigger('prev.owl.carousel');
        });
    }

    // Solution page
    if ($('.solutions-page-inner-page-crane').length > 0) {
        var solutionsOwl = $('.solutions-page-inner-page-crane .services .services-wrapper').owlCarousel({
            margin: 30,
            loop: false,
            rewind: false,
            nav: false,
            items: 3,
            stagePadding: 50,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 18,
                },
                500: {
                    items: 2,
                    stagePadding: 24,
                },
                801: {
                    items: 2,
                    stagePadding: 40,
                },
                1201: {
                    items: 3,
                    stagePadding: 50,
                },
                1441: {
                    items: 3,
                    stagePadding: 50,
                },
            },
        });

        $('.solutions-page-inner-page-crane .services .slider-buttons-wrapper .next-btn').on('click', function (e) {
            e.preventDefault();
            solutionsOwl.trigger('next.owl.carousel');
        });

        $('.solutions-page-inner-page-crane .services .slider-buttons-wrapper .prev-btn').on('click', function (e) {
            e.preventDefault();
            solutionsOwl.trigger('prev.owl.carousel');
        });
    }
    // Newsletter abonelik formu
    if ($('#newsletter-form').length > 0) {
        var showMessage = function (icon, message, reload) {
            Swal.fire({
                icon: icon,
                text: message,
                confirmButtonText: isTR ? 'Tamam' : 'OK',
                confirmButtonColor: '#A01D26'
            }).then(function () {
                if (reload) {
                    window.location.reload();
                }
            });
        };

        $('#newsletter-form').validate({
            rules: {
                email: { required: true, email: true },
                'newsletter-checkbox': { required: true }
            },
            errorPlacement: function () {}
        });

        $('#newsletter-submit').on('click', function () {

            if ($('#newsletter-form').valid()) {
                $.post('/forms/services/subscribe', {
                    email: $('#n-email').val()
                })
                .done(function () {
                    $('#n-email').val('');

                    showMessage('success', isTR
                        ? 'E-bülten aboneliğini tamamlamak için lütfen posta kutunuzu kontrol ediniz.'
                        : 'Please check your inbox to complete subscription.', true);
                })
                .fail(function () {
                    showMessage('error', isTR
                        ? 'Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.'
                        : 'An error occurred. Please try again later.', false);
                });
            } else {
                showMessage('warning', isTR
                    ? 'Lütfen geçerli bir e-posta adresi girin ve onay kutusunu işaretleyin.'
                    : 'Please enter a valid email address and check the consent box.', false);
            }

            return false
        });
    }
    normalizeInitialHashScroll();

});


$(function(){
    const $navWrapper = $('.navigation-wrapper');
    if ($navWrapper.length > 0) {
        // Carousel hazır olunca active item'a kay (on'dan önce bind edilmeli)
        $navWrapper.on('initialized.owl.carousel', function () {
            const $carousel = $(this);
            const activeIndex = $carousel.find('.owl-item').has('.navigation-item.active').index();
            if (activeIndex > -1) {
                setTimeout(function () {
                    $carousel.trigger('to.owl.carousel', [activeIndex, 300]);
                }, 50);
            }
        });

        $navWrapper.owlCarousel({
            stagePadding: 45,
            loop: false,
            rewind: false,
            nav: false,
            dots: false,
            items: 5,
            autoWidth: true,
            responsive: {},
            onInitialized: function() {
                $('.navigation-wrapper').css('opacity', 1);
            },
        });
    }

    // Trackpad'de iki parmakla yatay kaydirma owl'da calismiyor; wheel olayini
    // carousel'in prev/next komutuna ceviriyoruz.
    (function enableCarouselTrackpadSwipe() {
        var THRESHOLD = 40;   // slayt degistirmek icin gereken birikmis yatay delta
        var COOLDOWN = 260;   // iki slayt arasi minimum sure (ms)
        var accumulated = 0;
        var lastSlideAt = 0;
        var resetTimer = null;

        document.addEventListener('wheel', function (event) {
            if (!event.target || !event.target.closest) {
                return;
            }

            var el = event.target.closest('.owl-carousel.owl-loaded');
            if (!el) {
                return;
            }

            // Dikey niyet: sayfa normal kaysin.
            if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
                return;
            }

            var $owl = $(el);
            if ($owl.find('.owl-item').length < 2) {
                return;
            }

            // Tarayicinin geri/ileri gezinme hareketini engelle.
            event.preventDefault();

            var now = Date.now();
            if (now - lastSlideAt < COOLDOWN) {
                return;
            }

            accumulated += event.deltaX;
            clearTimeout(resetTimer);
            resetTimer = setTimeout(function () {
                accumulated = 0;
            }, 150);

            if (Math.abs(accumulated) < THRESHOLD) {
                return;
            }

            $owl.trigger(accumulated > 0 ? 'next.owl.carousel' : 'prev.owl.carousel');
            accumulated = 0;
            lastSlideAt = now;
        }, { passive: false });
    })();
})
